module.exports = __webpack_public_path__ + "img/vi_vn.8ea86dc1.png";